import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import EmployeeTranslation from '@/repositories/data/employees/EmployeeTranslation';

export default class RowTranslationRepository extends BaseCrudRepository<
    number,
    EmployeeTranslation,
    EmployeeTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/employee-translation/');
    }
}
